import React, { ChangeEvent, FC, JSX, ReactElement } from 'react';
import { Input, InputProps } from 'reactstrap';
import classNames from 'classnames';
import { sanitize } from '@ibe/services';

export interface CustomInputProps extends InputProps {
  label?: string | ReactElement;
  className?: string;
  htmlFor?: string;
}

const CustomInput: FC<CustomInputProps> = (props: CustomInputProps): JSX.Element => {
  const { label, className, htmlFor, id, onChange, type, ...inputProps } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!!onChange) {
      onChange(e);
    }
  };

  return (
    <div
      className={classNames('custom-control', className || '', {
        'custom-checkbox': type === 'checkbox'
      })}
    >
      {inputProps['aria-hidden'] !== 'true' ? (
        <Input
          className="custom-control-input"
          id={id}
          onChange={handleChange}
          type={type}
          {...inputProps}
          aria-label={inputProps?.['aria-label'] ?? label?.toString() ?? 'custom-control-label'}
        />
      ) : null}
      {(typeof label !== 'string' || type === 'checkbox') && inputProps['aria-hidden'] !== 'true' && (
        <label
          className="custom-control-label"
          aria-hidden={
            inputProps?.['aria-hidden'] === undefined
              ? undefined
              : inputProps?.['aria-hidden'] ?? 'true'
          }
          htmlFor={htmlFor || id}
          aria-label={
            inputProps?.['aria-label'] ? undefined : label?.toString() ?? 'custom-control-label'
          }
        >
          {label ?? ''}
        </label>
      )}
      {typeof label === 'string' && type !== 'checkbox' && (
        <label
          className="custom-control-label"
          htmlFor={htmlFor || id}
          dangerouslySetInnerHTML={{ __html: sanitize(label) }}
          aria-label={label ?? 'custom-control-label'}
        />
      )}
    </div>
  );
};

export default CustomInput;
